const baseURL = 'https://multicatalogo.komerzy.com/';

export default baseURL;
